var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.866 3L22.392 19.5C22.4798 19.652 22.526 19.8245 22.526 20C22.526 20.1755 22.4798 20.348 22.392 20.5C22.3042 20.652 22.178 20.7782 22.026 20.866C21.874 20.9538 21.7015 21 21.526 21H2.474C2.29847 21 2.12603 20.9538 1.97401 20.866C1.822 20.7782 1.69576 20.652 1.608 20.5C1.52023 20.348 1.47403 20.1755 1.47403 20C1.47403 19.8245 1.52024 19.652 1.608 19.5L11.134 3C11.2218 2.84799 11.348 2.72177 11.5 2.63401C11.652 2.54625 11.8245 2.50005 12 2.50005C12.1755 2.50005 12.348 2.54625 12.5 2.63401C12.652 2.72177 12.7782 2.84799 12.866 3ZM4.206 19H19.794L12 5.5L4.206 19ZM11 16H13V18H11V16ZM11 9H13V14H11V9Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert.6120f4c3038b64c58ad059604efa6962.svg";